export enum PricingType {
  GROSS = 'GROSS',
  NET = 'NET',
}
